import React from 'react'
import { Card,CardContent,CardDescription,CardFooter,CardHeader,CardTitle } from './card'
export default function Contact() {
  const d = new Date();
  return (
    <>

<div className='h-pit w-screen bg-gradient-to-b from-background via-muted to-background' id='contact'>
      <div className='w-full h-fit flex justify-center items-center'>
   

<Card className=' mt-10 text-center flex flex-col gap-8 p-4 border-0 bg-transparent'>
<CardTitle className='text-4xl'>Social And Contacts</CardTitle>
<CardDescription>you can contact me on these platforms.</CardDescription>
<CardContent className='flex flex-col lg:flex-row lg:gap-12 gap-5 justify-center items-center'>

<CardDescription><i class="fa-brands fa-instagram mr-1 text-pink-500 "></i> Instagram</CardDescription>
<CardDescription><i class="fa-brands fa-discord mr-1 text-indigo-500 "></i>Discord</CardDescription>
<CardDescription><i class="fa-solid fa-envelope mr-1 text-primary "></i>   ricedevlperngo@gmail.com</CardDescription>
<CardDescription><i class="fa-brands fa-youtube mr-1 text-red-500 "></i> youtube</CardDescription>
</CardContent>
</Card>


      </div>
    </div>
<div className='bg-accent w-full text-center text-sm h-[70px]  flex justify-center items-center text-primary border-t border-muted'>&#169; {d.getFullYear()} Soyong. <span className='text-sky-500 ml-1'>All rights reserved</span></div>
    </>
   
  )
}
